/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon32Regular = forwardRef('MediaUiAEjectIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.556 16.979C4.296 18.624 5.468 21 7.54 21h16.92c2.072 0 3.245-2.377 1.984-4.021l-8.46-11.035a2.5 2.5 0 0 0-3.968 0L5.556 16.98ZM7.54 19a.5.5 0 0 1-.397-.804l8.46-11.035a.5.5 0 0 1 .794 0l8.46 11.035a.5.5 0 0 1-.397.804H7.54Z" }),
        React.createElement("path", { d: "M6 24a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2H6Z" })));
});
